const TikTokIcon = () => {
  return (
    <>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_10_465)">
          <path
            d="M16 0C12.8355 0 9.74202 0.938384 7.11083 2.69649C4.47964 4.45459 2.42888 6.95345 1.21788 9.87707C0.00687148 12.8007 -0.309982 16.0177 0.307382 19.1214C0.924746 22.2251 2.4486 25.0761 4.68624 27.3137C6.92389 29.5513 9.77482 31.0752 12.8785 31.6926C15.9822 32.3099 19.1993 31.9931 22.1229 30.7821C25.0465 29.5711 27.5454 27.5203 29.3035 24.8891C31.0616 22.2579 32 19.1645 32 16C32 11.7565 30.3143 7.68687 27.3137 4.68629C24.3131 1.68571 20.2434 0 16 0V0ZM23.2126 14.2168C21.7852 14.3747 20.5621 13.8105 19.3389 13.0905C19.3389 13.2084 19.3747 16.8632 19.3137 18.6063C19.2526 20.3979 18.6126 21.9747 17.2084 23.1516C14.2315 25.6505 10.0063 24.3011 8.99785 20.48C8.45048 18.3979 8.92627 16.5221 10.56 15.0379C11.48 14.1958 12.6147 13.8211 13.8315 13.6653C14.0926 13.6316 14.3558 13.6168 14.6379 13.5916V16.4211C14.28 16.5095 13.9179 16.5874 13.5621 16.6926C13.3152 16.7639 13.0745 16.8547 12.8421 16.9642C12.5178 17.11 12.2315 17.3285 12.0053 17.6028C11.7791 17.8771 11.6191 18.1998 11.5377 18.5458C11.4562 18.8919 11.4556 19.2521 11.5358 19.5984C11.6159 19.9448 11.7748 20.2681 12 20.5432C12.2708 20.9176 12.6391 21.2106 13.0649 21.3903C13.4906 21.5699 13.9575 21.6294 14.4147 21.5621C15.3347 21.4505 15.9115 20.8716 16.2526 20.04C16.4884 19.3819 16.5908 18.6834 16.5536 17.9853C16.541 14.5495 16.541 11.1158 16.5347 7.68C16.5376 7.64466 16.5426 7.60952 16.5494 7.57474H19.2968C19.6042 9.87368 20.7705 11.3305 23.2126 11.5368V14.2168Z"
            fill="#1F2937"
          />
        </g>
        <defs>
          <clipPath id="clip0_10_465">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default TikTokIcon